<template>
  <div class="resource" :class="{ '-is-last': isLast }" ref="resource">
    <span class="page-type">{{ item.page_type }}</span>
    <br />
    <a :href="item.permalink">{{ item.post_title | ellipsize(90) }}</a>
    <p>{{ item.post_excerpt | ellipsize(90) }}</p>
  </div>
</template>

<script>
export default {
  props: ["item", "isLast"],
  filters: {
    ellipsize(value, cutoff) {
      value = value || "";

      return value.length > cutoff ? value.slice(0, cutoff) + "..." : value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../css/abstracts/path";
@import "../../../../css/abstracts/colors";

.resource {
  width: 100%;
  margin-bottom: 2.125rem;

  &.-is-last {
    margin-bottom: 0;
  }

  .page-type,
  a,
  p {
    margin-bottom: 0.375rem;
  }

  a {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 700;
  }

  .page-type {
    display: inline-block;
    text-transform: uppercase;
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 700;
    padding: 0.1875em 1rem 0.1875em 0.375em;
    position: relative;

    background-image: url(#{$assets}/images/resource-ribbon-edge.png);
    background-repeat: no-repeat;
    background-position: right center;
    background-size: cover;
  }
}
</style>
